function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "payment-pending_svg__a",
  x1: "50.147%",
  x2: "50.147%",
  y1: "100.155%",
  y2: "-.25%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "26%",
  stopColor: "#F69321"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "74%",
  stopColor: "#EF7700"
})));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.62 6.963c0 1.26.335 2.442.921 3.462h-2.6a3.051 3.051 0 00-2.205.814 3.03 3.03 0 00-.951 1.936l-.012.202v7.766a3.035 3.035 0 002.927 2.95l.178.001h9.6v1.942a1.58 1.58 0 01-1.438 1.477l-.146.006H1.584a1.582 1.582 0 01-1.569-1.338L0 26.036V8.484a1.582 1.582 0 011.438-1.478L1.584 7h14.037v-.037zm-1.742 5.167h4.04a6.917 6.917 0 001.955 1.248l.11.044a3.786 3.786 0 10.392.145 6.918 6.918 0 002.208.358c.982 0 1.916-.203 2.763-.57l.002.022v7.766a1.281 1.281 0 01-1.17 1.242l-.145.005H13.878c-.34.008-.67-.119-.917-.352a1.275 1.275 0 01-.386-.751l-.012-.144v-7.766c.008-.34.151-.661.398-.895.211-.2.484-.322.772-.348l.145-.004zm5.242 3.387a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm3.463-13.933a5.378 5.378 0 110 10.757 5.378 5.378 0 010-10.757zm-.19 2.438c-.35 0-.639.26-.685.597l-.006.094v3.453a.69.69 0 00.414.633l.097.034 2.244.605a.692.692 0 00.457-1.3l-.097-.034-1.734-.467V4.713a.69.69 0 00-.69-.691z",
  transform: "translate(0 -1)",
  fill: "url(#payment-pending_svg__a)",
  fillRule: "nonzero"
});

function SvgPaymentPending(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 27
  }, props), _ref, _ref2);
}

export default SvgPaymentPending;